var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3922 14.0251L15.7172 16.6584C15.8005 17.3501 15.0589 17.8334 14.4672 17.4751L10.9755 15.4001C10.5922 15.4001 10.2172 15.3751 9.85053 15.3251C10.4672 14.6001 10.8339 13.6834 10.8339 12.6917C10.8339 10.3251 8.78386 8.40844 6.25052 8.40844C5.28386 8.40844 4.39219 8.68341 3.65053 9.16675C3.62553 8.95841 3.61719 8.75007 3.61719 8.53341C3.61719 4.74174 6.90886 1.66675 10.9755 1.66675C15.0422 1.66675 18.3339 4.74174 18.3339 8.53341C18.3339 10.7834 17.1755 12.7751 15.3922 14.0251Z",
    stroke: "url(#paint0_linear_1497_3130)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 12.6917C10.8327 13.6834 10.466 14.6001 9.84936 15.3251C9.02436 16.3251 7.71602 16.9667 6.24935 16.9667L4.07435 18.2584C3.70768 18.4834 3.24101 18.1751 3.29101 17.7501L3.49935 16.1084C2.38268 15.3334 1.66602 14.0917 1.66602 12.6917C1.66602 11.2251 2.44935 9.93342 3.64935 9.16676C4.39102 8.68342 5.28268 8.40845 6.24935 8.40845C8.78268 8.40845 10.8327 10.3251 10.8327 12.6917Z",
    stroke: "url(#paint1_linear_1497_3130)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1497_3130",
    x1: 2.62211,
    y1: 14.933,
    x2: 19.2809,
    y2: 2.95495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1497_3130",
    x1: 1.0462,
    y1: 16.6745,
    x2: 11.425,
    y2: 9.21448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.020b493a09a0e304035d01fd151b124b.svg";
export { ForwardRef as ReactComponent };